"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');




var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _blobject = require('shared/selectors/blobject');
var _user = require('shared/selectors/user');
var _time = require('shared/services/time');
var _unread = require('shared/services/unread');
var _hooks = require('web/services/hooks');

// The seen time that leaves nothing in a chat unread: its inbox sort time, or
// its newest message's when that is later. The sort time also moves for items
// you can't scroll past as a message (a chat created, a START text), so seen up
// to the newest message alone can leave the chat unread for good.
 const readThroughTime = (inboxSortTime, newestSentAt) =>
  newestSentAt && (!inboxSortTime || _time.isLaterTime.call(void 0, newestSentAt, inboxSortTime))
    ? newestSentAt
    : inboxSortTime; exports.readThroughTime = readThroughTime

const selectReadThroughTime = (state, blobjectKey, conversationKey) => {
  const messages = state.dataV2.messages[conversationKey]
  return exports.readThroughTime.call(void 0, 
    _optionalChain([_blobject.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _ => _.InboxSortTime]),
    _optionalChain([messages, 'optionalAccess', _2 => _2[messages.length - 1], 'optionalAccess', _3 => _3.SentAt]),
  )
}

/* Opening a chat marks all of it read, so its inbox row turns read at once,
 * and clears "Mark as unread" even when nothing is newer than the seen time.
 * Returns the seen time the chat had when it opened: the view anchors on it to
 * land on, and mark, the first new message as before. */
 const useMarkReadOnOpen = (blobjectKey, conversationKey) => {
  const hasBlobject = _hooks.useAppSelector.call(void 0, state => !!_blobject.selectBlobjectByKey.call(void 0, state, blobjectKey))
  const seenTime = _hooks.useAppSelector.call(void 0, state => _blobject.selectMyBlobjectLastSeenTime.call(void 0, state, blobjectKey))
  const readThrough = _hooks.useAppSelector.call(void 0, state => selectReadThroughTime(state, blobjectKey, conversationKey))
  const isActive = _hooks.useAppSelector.call(void 0, _user.selectIsCurrentUserActive)
  const isMarkedUnread = _hooks.useAppSelector.call(void 0, state => _blobject.selectIsMarkedUnreadByMe.call(void 0, state, blobjectKey))

  // Taken once the chat is in the store, before the mark below changes it.
  const anchor = _react.useRef(undefined)
  if (anchor.current === undefined && hasBlobject) anchor.current = seenTime

  const hasMarked = _react.useRef.call(void 0, false)
  _react.useEffect.call(void 0, () => {
    // An inactive window hasn't been looked at; it marks when it comes back.
    if (hasMarked.current || !isActive || !readThrough) return
    hasMarked.current = true
    const SeenTime = _unread.seenTimeOnOpen.call(void 0, readThrough, seenTime, isMarkedUnread)
    if (!SeenTime) return
    _actions2.default.markBlobjectSeen({ BKey: blobjectKey, SeenTime })
      .catch(() => null)
  }, [blobjectKey, isActive, readThrough, seenTime, isMarkedUnread])

  return anchor.current
}; exports.useMarkReadOnOpen = useMarkReadOnOpen
